var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../../../Base.js";
import Model from "../../../data/Model.js";
import StateTrackingManager from "../../../data/stm/StateTrackingManager.js";
var StoreStm_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    changeStm(stm, oldStm) {
      var _a2;
      if ((_a2 = oldStm == null ? void 0 : oldStm.hasStore) == null ? void 0 : _a2.call(oldStm, this)) {
        oldStm.removeStore(this);
      }
      if (stm) {
        if (!stm.isStateTrackingManager) {
          stm = new StateTrackingManager(stm);
        }
        if (!stm.hasStore(this)) {
          stm.addStore(this);
        }
      }
      return stm;
    }
    // Overridden to notify STM about flat add action
    add(records, silent = false, options = {}) {
      let result;
      const { stm } = this;
      if (!this.tree && (stm == null ? void 0 : stm.shouldRecordAction)) {
        result = super.add(records, silent, options);
        if (result == null ? void 0 : result.length) {
          stm.onStoreModelAdd(this, result, silent);
        }
      } else {
        result = super.add(records, silent, options);
      }
      return result;
    }
    // Overridden to notify STM about flat insert action
    insert(index, records, silent = false) {
      let result;
      const { stm } = this;
      if (!this.tree && (stm == null ? void 0 : stm.shouldRecordAction)) {
        const context = (Array.isArray(records) ? records : [records]).reduce(
          (context2, r) => {
            const index2 = r instanceof Model ? this.indexOf(r) : void 0;
            if (index2 !== void 0 && index2 !== -1) {
              context2.set(r, index2);
            }
            return context2;
          },
          /* @__PURE__ */ new Map()
        );
        result = super.insert(index, records);
        if (result == null ? void 0 : result.length) {
          index = this.indexOf(result[0]);
          stm.onStoreModelInsert(this, index, result, context, silent);
        }
      } else {
        result = super.insert(index, records, silent);
      }
      return result;
    }
    // Overridden to notify STM about flat removing action
    remove(recordsOrIds, silent = false, fromRemoveChild) {
      let result;
      const { stm } = this;
      if (!this.tree && (stm == null ? void 0 : stm.shouldRecordAction)) {
        const recordsOrIdsNormalized = (Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds]).map((r) => this.getById(r)).filter((r) => Boolean(r));
        const context = recordsOrIdsNormalized.reduce(
          (context2, r) => {
            const index = this.indexOf(r);
            if (index !== void 0 && index !== -1) {
              context2.set(r, index);
            }
            return context2;
          },
          /* @__PURE__ */ new Map()
        );
        result = super.remove(recordsOrIds, silent, fromRemoveChild);
        if (result == null ? void 0 : result.length) {
          stm.onStoreModelRemove(this, result, context, silent);
        }
      } else {
        result = super.remove(recordsOrIds, silent, fromRemoveChild);
      }
      return result;
    }
    // Overridden to notify STM about flat clear action
    removeAll(silent) {
      const { stm } = this;
      let result;
      if (stm == null ? void 0 : stm.shouldRecordAction) {
        const { tree, rootNode, allRecords } = this, wasNotEmpty = allRecords.length, records = tree ? rootNode.children.slice() : allRecords.slice();
        result = super.removeAll(silent);
        if (wasNotEmpty && this.count === 0) {
          stm.onStoreRemoveAll(this, records, silent);
        }
      } else {
        result = super.removeAll(silent);
      }
      return result;
    }
    beforeApplyChangeset() {
      const { stm, crudManager } = this;
      let shouldResume = false, transactionId = null;
      if (!(crudManager == null ? void 0 : crudManager.applyingChangeset) && (stm == null ? void 0 : stm.enabled) && !stm.isNavigatingRevisions) {
        shouldResume = true;
        if (stm.isRecording) {
          transactionId = stm.stash();
        }
        if (this.ignoreRemoteChangesInSTM) {
          stm.disable();
        } else {
          stm.startTransaction();
        }
      }
      return { shouldResume, transactionId };
    }
    // When applying changes while STM is in the recording state, first we need to discard local changes, then apply
    // changes from remote, then try to apply local changes. This would emulate starting transaction as if data was
    // already in the correct state
    applyChangeset(changes, ...args) {
      const {
        shouldResume,
        transactionId
      } = this.beforeApplyChangeset(), log = super.applyChangeset(changes, ...args);
      this.afterApplyChangeset(shouldResume, transactionId);
      return log;
    }
    afterApplyChangeset(shouldResume, transactionId) {
      if (shouldResume) {
        const { stm } = this;
        if (this.ignoreRemoteChangesInSTM) {
          stm.enable();
        } else {
          stm.stopTransaction();
        }
        stm.applyStash(transactionId);
      }
    }
  }, __publicField(_a, "$name", "StoreStm"), __publicField(_a, "configurable", {
    /**
     * Reference to STM manager
     *
     * @config {Core.data.stm.StateTrackingManager}
     * @default
     * @category Advanced
     */
    stm: null,
    /**
     * Set to `false` to not record transaction during `applyChangeset` call
     *
     * @prp {Boolean}
     * @default
     * @category Advanced
     */
    ignoreRemoteChangesInSTM: false
  }), _a;
};
export {
  StoreStm_default as default
};
